import { Marker, Polygon } from "react-leaflet";
import L from "leaflet";
import LeafletMap, { FitBounds, polygonCentroid } from "@/components/map/LeafletMap";

const pin = L.divIcon({
  className: "",
  iconSize: [22, 22],
  iconAnchor: [11, 11],
  html: `<div style="width:22px;height:22px;border-radius:9999px;background:#EF4444;border:3px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.35)"></div>`,
});

export default function ZonePinPreview({ lat, lng, zones = [], boundary = [], height = 200 }) {
  const has = lat != null && lng != null && !isNaN(Number(lat)) && !isNaN(Number(lng));
  const la = has ? Number(lat) : null;
  const ln = has ? Number(lng) : null;
  const allPts = [...zones.flatMap((z) => z || []), ...(boundary || [])];
  const center = has ? [la, ln] : (polygonCentroid(zones[0] || []) || [41.75, -71.3]);
  return (
    <div data-testid="zone-pin-preview" className="rounded-lg overflow-hidden border border-border">
      <LeafletMap height={height} center={center} zoom={has ? 14 : 12}>
        {boundary?.length >= 3 && <Polygon positions={boundary} pathOptions={{ color: "#64748B", weight: 2, fillOpacity: 0.04, dashArray: "6" }} />}
        {zones.map((z, i) => (z?.length >= 3) && <Polygon key={i} positions={z} pathOptions={{ color: "#EF4444", fillColor: "#FACC15", weight: 2, fillOpacity: 0.2 }} />)}
        {has && <Marker position={[la, ln]} icon={pin} />}
        {has
          ? <FitBounds bounds={[[la - 0.004, ln - 0.004], [la + 0.004, ln + 0.004]]} nonce={`${la},${ln}`} />
          : (allPts.length >= 2 && <FitBounds bounds={allPts} nonce={`z${allPts.length}`} />)}
      </LeafletMap>
    </div>
  );
}
